import * as z from "zod";

export const updateLinearTicketPriority = {
  name: "updateLinearTicketPriority" as const,
  input: z.object({
    linearTicketId: z.string(),
    priority: z.number().int().min(0).max(4),
  }),
  output: z.object({
    success: z.boolean(),
    newPriority: z.number().nullable(),
    newPriorityLabel: z.string().nullable(),
    error: z.string().nullable().optional(),
  }),
};
